<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/

:root {
  --body-bg-color: #f3f6f9;
  --primary-color: #e56715;
  --secondary-color: #f2883a;
  --primary-text-color: #000;
  --secondary-text-color: #ffffff;

  //Login
  --login-bg-color: #18262e;
  --login-primary-color: #00458f;
  --login-secondary-color: #f2883a;

  //buttons
  --button-bg-color: #00458f;
  --button-primary-color: #38d;
  --button-secondary-color: #16b;
  --button-primary-text-color: #00458f;
  --button-secondary-text-color: #f2883a;

  //Sidebar
  --sidebar-primary-color: #ec2849;
  --sidebar-secondary-color: #1e2a2d;
  --sidebar-primary-text-color: #fff;
  --sidebar-secondary-text-color: #ffffff;
  --sidebar-bg-color: #e56715;
  --sidebar-active-menu-bg-color: #e56715;
  --sidebar-active-menu-text-color: #ffffff;
  --sidebar-menu-text-color: #ffffff;

  //Sub Header
  --header-primary-color: #eab308;
  --header-secondary-color: #ffffff;
  --header-primary-text-color: #ffffff;
  --header-secondary-text-color: #1e303e;

  --sub-header-bg-color: blue;
  --sub-header-text-color: blue;
  --color-white: #fff;
  --color-dark: #212121;
}
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";

export default {
  name: "AbsentNote",
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  }
};
</script>
